import React from "react";
import QuotaRoundList from "./QuotaRoundList";

/**
 * บัณฑิตศึกษา ปริญญาโท (/Register/3) และปริญญาเอก (/Register/4)
 * ทั้งสอง param หลังบ้านส่งรอบชุดเดียวกันมา (QUOTA_ID 7) จึงไม่ต้องกรอง
 */
function GraduateRounds({ rounds, selectedRobId, onSelect }) {
  return (
    <QuotaRoundList
      rounds={rounds}
      selectedRobId={selectedRobId}
      onSelect={onSelect}
    />
  );
}

export default GraduateRounds;
